// Dependencies
import React, { useState } from "react";
import { Link, getMatchedRouteKeyValue, push } from "yarrr";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

// components
import Avatar from "Components/Avatar";
import BrowserLogo from "Components/BrowserLogo";

// Hooks
import useRequest from "Hooks/useRequest";

// Utils
import get from "Utils/get";

// styles
import css from "./FlameChart.styl";

const Flame = ({ request, minTime, totalTime }) => {
	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = useState(false);

	const handleClick = () => {
		// setIsOpen(!isOpen);
		dispatch(push(`/flame/${request.request}`));
	};

	const xPosition = ((request.start_time - minTime) / totalTime) * 100;
	const width = ((request.end_time - request.start_time) / totalTime) * 100;

	return (
		<div onClick={handleClick} style={{ left: `${xPosition}%`, width: `${width}%` }} className={css.request}>
			<div className={css.requestName}>
				{request.url} ({request.delta_time * 1000} ms)
			</div>
		</div>
	);
};

const FlameChart = () => {
	const requestID = useSelector((state) => getMatchedRouteKeyValue(state, "requestID", null));
	const { data } = useRequest("Get Request Flame Chart", { filters: { requestID } });

	if (!data) {
		return null;
	}

	let maxTime = 0;
	let minTime = Infinity;

	const userID = get(["request", "user", "_id"], data, "");
	const userName = get(["request", "user", "name"], data, "");
	const companyID = get(["request", "company_id"], data, "");
	const companyName = get(["request", "user", "company"], data, "");
	let startTime = get(["request", "start_time"], data, "");
	let deltaTime = get(["request", "delta_time"], data, "");
	const handler = get(["request", "handler"], data, "");
	const method = get(["request", "method"], data, "");

	if (startTime !== "") {
		const dateObj = new Date(get(["request", "start_time"], data, "") * 1000);
		startTime = format(dateObj, "MMM dd, yyyy hh:mm:ss a");
	}

	if (deltaTime !== "") {
		console.log(deltaTime, "delta");
		deltaTime = `${(deltaTime * 1000).toFixed(3)} ms`;
	}

	[...data.requests, data.request].forEach((request) => {
		request.totalTime = request.end_time - request.start_time;

		if (request.start_time < minTime) {
			minTime = request.start_time;
		}

		if (request.end_time > maxTime) {
			maxTime = request.end_time;
		}
	});

	const totalTime = maxTime - minTime;

	// remove invalid total times
	let requests = data.requests.filter((request) => !isNaN(request.totalTime));

	// sort by total time and start time
	requests = requests.sort((a, b) => b.totalTime - a.totalTime);

	return (
		<div className={css.main}>
			<h1>Flame Chart</h1>
			<div className={css.requestInfo}>
				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Requested By</div>
					<div className={css.avatarWrapper}>
						<Avatar size={25} className={css.userAvatar} userID={userID} />
					</div>
					<div className={`${css.fieldValue} ${css.link}`}>
						<Link href={`/breadcrumbs/${userID}/`}>{userName}</Link>
					</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Company</div>
					<div className={`${css.fieldValue} ${css.link}`}>
						<Link href={`/companies/${companyID}/`}>{companyName}</Link>
					</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Start Time</div>
					<div className={css.fieldValue}>{startTime}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Total Time</div>
					<div className={css.fieldValue}>{deltaTime}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Method</div>
					<div className={css.fieldValue}>{method}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Handler</div>
					<div className={css.fieldValue}>{handler}</div>
				</div>
			</div>

			<div className={css.parent}>
				<div className={css.mainRequest}>
					<Flame request={data.request} totalTime={totalTime} minTime={minTime} />
				</div>

				{requests.map((request, index) => (
					<div key={request.request} className={css.requestWrapper}>
						<Flame key={request.request} request={request} totalTime={totalTime} minTime={minTime} />
					</div>
				))}
			</div>
		</div>
	);
};

export default FlameChart;
